import React from 'react'
import PropTypes from 'prop-types'
import FieldsSeparator from '../../atoms/FieldsSeparator'
import { ChevronRight } from '@mui/icons-material'
import { TextButton } from '../../molecules/buttons/TextButton'

const StatCard = ({ icon, title, value, indicator, onShowMore }) => {
  return (
    <div className="bg-white shadow-md rounded-lg p-6 flex flex-col hover:shadow-lg transition-shadow sm:min-w-60">
      <div className="flex gap-3 items-center mb-4">
        <img src={icon} alt="" className="w-9 h-9" />
        <h3 className="font-bold text-base pr-10">{title}</h3>
      </div>
      <p className="text-4xl font-bold">{value}</p>
      <FieldsSeparator />
      <TextButton
        onClick={() => onShowMore(indicator)}
        className="font-bold w-fit"
        endIcon={<ChevronRight className="w-6 h-6" />}
      >
        Ver más
      </TextButton>
    </div>
  )
}

StatCard.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  indicator: PropTypes.string.isRequired,
  onShowMore: PropTypes.func.isRequired
}

export default StatCard
